import {ApolloError} from "@apollo/client";

import {ERROR_ACCESS_DENIED, ERROR_FEATURE_NOT_SUPPORTED} from "@/lib/api/errorCodes.tsx";

export const redirectIfUnavailableFabric = (feature: string) => {
  // eslint-disable-next-line no-unused-vars
  return (error: unknown, _componentStack: string | undefined, _eventId: string) => {
    if (!(error instanceof ApolloError)) {
      return;
    }

    const graphQLErrorCode = (error as ApolloError)?.graphQLErrors[0]?.extensions?.code;

    if (graphQLErrorCode === ERROR_FEATURE_NOT_SUPPORTED) {
      window.history.pushState({feature}, "", `/feature-unavailable?f=${feature}`);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } else if (graphQLErrorCode === ERROR_ACCESS_DENIED) {
      window.history.pushState({resetBoundary: true}, "", "/access-denied");
      window.dispatchEvent(new PopStateEvent("popstate"));
    }

    return;
  };
};
